import * as $ from 'jquery';

export class Helpers {

  static unwrapTag(element) {
    $(element).removeAttr('appunwraptag').unwrap();
  }

  static setLoading(enable) {
    const body = $('body');
    if (enable) {
      $(body).addClass('m-page--loading-non-block');
    } else {
      $(body).removeClass('m-page--loading-non-block');
    }
  }

  static bodyClass(strClass) {
    $('body').attr('class', strClass);
  }

  static RemoveModal() {
    $('.modal-backdrop').remove();
  }
}
